import { IConfigSecurity } from '@shared/interface/config.interface';

export const DRAWER_WIDTH_DESKTOP = 240;

export const defaultSecurity: IConfigSecurity = {
  username: {
    authCar: '',
    min: 3,
    max: 64,
  },
  password: {
    authCar: '_-+*#$!?',
    min: 8,
    max: 16,
  },
  secretCode: {
    authCar: '',
    min: 4,
    max: 12,
  },
};
